import {
  Editor,
  Element as SlateElement,
  Node,
  Path,
  Point,
  Range,
  Transforms,
} from "slate";
import { CustomEditor, ParagraphElement } from "../types";

export const withLayout = (editor: CustomEditor) => {
  const { insertBreak, deleteBackward } = editor;

  editor.insertBreak = () => {
    const { selection } = editor;
    if (selection) {
      // If we're at the start of a non-empty node, insert a new node before
      const [node] = Editor.node(editor, selection);
      const start = Editor.start(editor, selection.anchor.path);
      const isAtStart =
        selection.anchor.offset === 0 && selection.focus.offset === 0;
      const isEmpty =
        SlateElement.isElement(node) && node.children[0]?.text === "";

      if (isAtStart && !isEmpty) {
        Transforms.insertNodes(editor, {
          type: "paragraph",
          children: [{ text: "" }],
        } as ParagraphElement);
        return;
      }
    }
    insertBreak();

    // After inserting break, check if we created an empty node
    const currentSelection = editor.selection;
    if (currentSelection) {
      const [currentNode] = Editor.node(editor, currentSelection);
      if (SlateElement.isElement(currentNode)) {
        const prevPath = Path.previous(currentSelection.anchor.path);
        try {
          const prevNode = Node.get(editor, prevPath);
          if (SlateElement.isElement(prevNode)) {
            // If both current and previous nodes are empty, merge them
            if (
              currentNode.children[0]?.text === "" &&
              prevNode.children[0]?.text === ""
            ) {
              Transforms.mergeNodes(editor);
            }
          }
        } catch (e) {
          // Previous path might not exist, ignore
        }
      }
    }
  };

  editor.deleteBackward = (...args) => {
    const { selection } = editor;
    if (selection && Range.isCollapsed(selection)) {
      const match = Editor.above(editor, {
        match: (n) => SlateElement.isElement(n) && Editor.isBlock(editor, n),
      });

      if (match) {
        const [block, path] = match;
        const start = Editor.start(editor, path);

        if (
          SlateElement.isElement(block) &&
          block.children[0]?.text === "" &&
          Point.equals(selection.anchor, start)
        ) {
          const prevPath = Path.previous(path);
          try {
            const prevNode = Node.get(editor, prevPath);
            if (
              SlateElement.isElement(prevNode) &&
              prevNode.children[0]?.text === ""
            ) {
              Transforms.mergeNodes(editor);
              return;
            }
          } catch (e) {
            // Previous path might not exist, ignore
          }
        }
      }
    }
    deleteBackward(...args);
  };

  return editor;
};
